module.exports = __webpack_public_path__ + "assets/img/img_anbjpop.073611a6.png";